import { render, staticRenderFns } from "./FreePlanSection.vue?vue&type=template&id=33ff799f&"
import script from "./FreePlanSection.vue?vue&type=script&lang=js&"
export * from "./FreePlanSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports